"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5057],{

/***/ 85057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HomeMap": function() { return /* binding */ HomeMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _parkschannel_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67731);
/* harmony import */ var _parkschannel_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(502);
/* harmony import */ var _PinsMap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7744);
/* harmony import */ var _PinsMap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94525);
/* harmony import */ var _PinsMap_components_Popup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31357);
/* harmony import */ var _Video__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35715);






const HomeMap = ()=>{
    const { setSelectedVideo  } = (0,_Video__WEBPACK_IMPORTED_MODULE_2__/* .useVideoModalContext */ .sw)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_map__WEBPACK_IMPORTED_MODULE_3__/* .MapBoundsProvider */ .PL, {
        defaultBounds: _parkschannel_map__WEBPACK_IMPORTED_MODULE_4__/* .MAP_BOUNDS */ .QJ,
        defaultZoom: _parkschannel_map__WEBPACK_IMPORTED_MODULE_4__/* .MAP_ZOOM */ .Gr,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PinsMap__WEBPACK_IMPORTED_MODULE_5__/* .PinsMapProvider */ .Q, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PinsMap__WEBPACK_IMPORTED_MODULE_6__/* .PinsMap */ ._, {
                scrollZoom: false,
                onMapLoad: (map)=>map.getMap().scrollZoom.disable(),
                style: {
                    height: "70vh",
                    maxHeight: "750px"
                },
                popup: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PinsMap_components_Popup__WEBPACK_IMPORTED_MODULE_7__/* .ThumbnailPopup */ .b, {
                    setSelectedVideo: setSelectedVideo,
                    className: "maxLg:!bottom-2"
                }),
                initialViewState: {
                    zoom: _parkschannel_map__WEBPACK_IMPORTED_MODULE_4__/* .MAP_ZOOM */ .Gr,
                    bounds: [
                        [
                            -125.0011,
                            24.9493
                        ],
                        [
                            -66.9326,
                            49.5904
                        ]
                    ]
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomeMap);


/***/ })

}]);